/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Created for Universe App Tools.
 * 
 * Created by Justin K Kazmierczak.
 */

/*
<div class="form-group pb-3">
    <label for="${name}" class="pb-2 fs-4">${title}</label>
    <div class="input-group">
        <div class="input-group-prepend">
            <div class="input-group-text rounded-0 rounded-start input-icon-block"><i class="${icon}"></i></div>
        </div><input id="${name}" class="form-control is-invalid" title="${title}">
    </div>
</div>
*/
var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.input",
  title: "Form Group: Text Box",
  description: "A form group with a text box.",
  control: true,
  preview: "ua.preview.input",
  prevalidate: true,
  supportServer: false,
  fields: {
    "name": {
      title: "Name",
      type: "string",
      description: "The name of the control.",
      required: true
    },
    "title": {
      title: "Title",
      type: "string",
      description: "The title of the control.",
      required: true
    },
    "icon": {
      title: "Icon",
      type: "string",
      description: "The icon of the control.",
      required: false
    },
    "type": {
      title: "Type",
      type: "string",
      description: "The type of the control.",
      list: {
        suggest: ["text", "password", "date", "email", "number", "tel", "url", "search", "time", "textarea"]
      },
      default: "text"
    },
    "value": {
      title: "Value",
      type: "string",
      description: "The value of the control.",
      required: false
    }, "inputClass": {
      title: "Input Class",
      type: "string",
      description: "The class of the input."
    }, "inputStyle": {
      title: "Input Style",
      type: "string",
      description: "The style of the input."
    }, "description": {
      title: "Description",
      type: "inner",
      description: "The helpful text at the bottom of the control."
    }
  },
  passthrough: {
    except: ["inner", "type", "id", "inputclass", "inputstyle", "description"]
  }
});

var jsonRender = require("../interface/jsonRender.js");
var uai = require("../interface/interface.js");

 
/**
 * Preparing migration to jsonRender and uae.render();
 * @param {*} options The object to render
 * @returns a ua.code dom element
 */
exports.render = async function (options) {

  var randomName = uai.generateRandomID(12);
  var inputId = options.id || randomName;

  var isTextarea = options.type === "textarea";
  var _input = {
    "n": isTextarea ? "textarea" : "input",
    "id": inputId,
    "class": "form-control",
    "title": options.title
  };

  if ("value" in options && options.value !== undefined && options.value !== null) {
    if (isTextarea) {
      _input.i = options.value;
    } else {
      _input.value = options.value;
    }
  }


  /** corrections for quick values for controls */
  //corrections for type=date
  if (options.type == "date") {
    //if max or min is in options and equal to now auto set the value
    if ("max" in options) {
      if (options.max == "now") {
        options.max = new Date().toISOString().split("T")[0];
      }
    }

    if ("min" in options) {
      if (options.min == "now") {
        options.min = new Date().toISOString().split("T")[0];
      }
    }
  }

  try {
    // console.log("*** Opt 1", {
    //   options, _input});

      _input = jsonRender.pass({...options}, {..._input}, ["name", "class", "icon", "style", "description"]);

      if (isTextarea) {
        delete _input.type;
        delete _input.value;
      }

      // console.log("My new input", myNewInput);

    // _input = await jsonRender.pass(options, _input, ["name", "class", "icon", "style"]);
  } catch (error) {
    // console.log(`ua.input Error: ${error}`);
  }

// console.log("*** Opt 2", JSON.stringify([options, _input], null, 2));

  // console.log("Input", {input, options});

  if ("inputclass" in options) {
    _input.class += " " + options.inputclass;
  }

  // console.log("*** Opt 3", JSON.stringify([options, _input], null, 2));

  if ("inputstyle" in options) {
    _input.style = options.inputstyle;
  }

//   console.log("*** Opt 4", JSON.stringify([options, _input], null, 2));

// console.log("*** Opt 5", JSON.stringify([options, _input], null, 2));


  var element = {
    "n": "div",
    "name": options.name,
    "c": "form-group pb-3",
    "i": [{
      "n": "label",
      "for": inputId,
      "c": "pb-2 fs-4",
      "i": options.title
    }, {
      "n": "div",
      "c": "input-group",
      "i": ""
    }]
  }

  // console.log("*** Opt 6", JSON.stringify([options, _input], null, 2));

  //if icon already contains bi bi- than remove that part
  if ("icon" in options) {
    if (options.icon.startsWith("bi bi-")) {
      options.icon = options.icon.replace("bi bi-", "");
    }
  }

  //if it contians just bi- then remove that part
  if ("icon" in options) {
    if (options.icon.startsWith("bi-")) {
      options.icon = options.icon.replace("bi-", "");
    }
  }

  //if icon is provided
  if ("icon" in options) {
    element.i[1].i= [{
      "n": "div",
      "c": "input-group-prepend",
      "i": [{
        "n": "div",
        "c": "input-group-text rounded-0 rounded-start input-icon-block",
        "i": [{
          "n": "i",
          "class": "bi bi-" + options.icon
        }]
      }]
    }, _input];
  } else {
    element.i[1].i = _input;
  }

  //add <div id="passwordHelpBlock" class="form-text">${options.description}</div>/*
  if ("description" in options) {
    _input["aria-describedby"] = `${inputId}-description`;
    element.i.push({
      "n": "div",
      "id": `${inputId}-description`,
      "c": "form-text",
      "i": options.description
    });
  }
  
  // console.log("*** Opt 7", {options, _input});

  // console.log("ua.input Sending an element", JSON.stringify([element, options], null, 2));

  var domElement = await jsonRender.render(element);

  // console.log("The Dom Element", domElement);

  var input = domElement.querySelector("input, textarea");

  // var focusFunction = (event) => {
  //   var uaeElement = this.closest("uae");
  //   // console.info(
  //   //     "Radio Group Change",
  //   //     { uaeElement }
  //   // );
  //   save(options.name, uaeElement, {});
  // }

  // console.log("The Input", input);

  input.addEventListener("change", function (event) {
    //get the uae element plceholder
    var uaeElement = this.closest("uae");
    // console.info(
    //     "Radio Group Change",
    //     { uaeElement }
    // );
    save(options.name, uaeElement, {});
  });

  // Live valid/invalid feedback while typing, debounced so we don't validate on
  // every keystroke. Scoped to this control only — no error text is shown here;
  // error messages stay gated to explicit next/continue/save (ua.wizard's _validateStep).
  var debounceTimer = null;
  input.addEventListener("input", function () {
    var uaeElement = this.closest("uae");
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      save(options.name, uaeElement, {});
    }, 400);
  });

  // input.addEventListener("change", focusFunction);
  // input.addEventListener("focusout", focusFunction);

  // console.log("*** Opt 9", options);

  return domElement;

}

// async function focus(event) {
//   // console.log("focus", event);


//   //get the parent uae element
//   var parent = this.closest("uae");

//     this.classList.remove("is-invalid");
//     this.classList.remove("is-valid");

//     //if the input is not empty
//     if (this.value.trim() != "") {
     
//       if (validation(parent).length > 0) {
//         parent.classList.add("is-invalid");
//         this.classList.add("is-invalid");
//       } else {
//         parent.classList.add("is-valid");
//         this.classList.add("is-valid");
//       }

//     }
// }


function validation(control) {
  var input = control.querySelector("input, textarea");
  var errors = [];


  if (!(input.checkValidity())) {
    // console.log("Input invalid", input.validationMessage);
    errors.push({
      type: "validation",
      message: input.validationMessage
    });
  }

  return errors;
}


/**
 * Saves the code from the iframe.
 * Called by UATools.
 * @param {*} name The name of the control.
 * @param {*} control The control to save.
 * @param {*} repo The repo (used to send back), with the prevalidation results.
 * @property {*} repo.success The success object (is this field ready to be saved).
 * @property {*} repo.data The actual data object that will be saved. JSON encodable only (no functions or promises).
 * @property {*} repo.errors The error's applied to the object. Should be an array, can have more than one item.
 * @property {*} repo.errors.input If appliable, the direct input that caused the erorr - it must be an object. If input is not provided the control will be highlighted.
 * @property {*} repo.errors.input.id The id of the input field, if applicable.
 * @property {*} repo.errors.input.name The name of the input field if applicable.
 * @property {*} repo.errors.type The type of error that occured.
 *  - Supports: "validation" - The input or field or control is invalid
 *  - Supports: "thowable" - Processing this field caused a throwable to error out.
 * @property {*} repo.errors.message The message to display to the user.
 * @returns The repo object with the data to save
 */
async function save(name, control, repo) {

  // console.log("Starting save", {
  //   control, repo
  // });


  //get the input from the control and check if it's valid
  var input = control.querySelector("input, textarea");


  //if input has a min length but value is empty
  // if (input.minLength > 0 && input.value.trim() == "") {
  //   // console.log("Input invalid", "Input is empty");
  //   repo.success = false;
  //   repo.errors.push({
  //     type: "validation",
  //     message: "This field is required.",
  //     input: {
  //       id: input.id,
  //       name: input.name
  //     }
  //   });
  // }


  control.classList.remove("is-invalid");
  control.classList.remove("is-valid");


  repo.errors = validation(control);
  if (repo.errors.length > 0) {
    repo.success = false;
    control.classList.add("is-invalid");
  } else {
    repo.success = true;
    control.classList.add("is-valid");
  }


  repo.data = input.value;

  // console.log("Ending save", {
  //   control, repo
  // });

  return repo;

} module.exports.save = save;

/**
 * Loads the control with data.
 * @param {*} name The name of the control.
 * @param {*} control The control itself (including placeholder tag).
 * @param {*} data The data to load into the control.
 */
async function load(name, control, data) {

  //get the input from the control
  var input = control.querySelector("input, textarea");

  //ensure that I won't update the control if the data is empty and it's already empty
  //if the data is null or undefined and the input is empty
  if (!(data) || data == "" && input.value == "") {
    return;
  }

  //set the value
  input.value = data;

} module.exports.load = load;
